// extracted by mini-css-extract-plugin
export default {"list":"ParariusOfficeListingNotFoundErrorPage_list__Ef7WR","boldList":"ParariusOfficeListingNotFoundErrorPage_boldList__ageWe"};